module.exports = __webpack_public_path__ + "img/bg1.8a915790.jpg";